import React, { useEffect, useState } from 'react';
import { Shield, Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Threats',
    href: '#threats'
  }, {
    name: 'Solutions',
    href: '#solutions'
  }, {
    name: 'Pricing',
    href: '#pricing'
  }, {
    name: 'Trust',
    href: '#trust'
  }];
  return <motion.nav initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.5
  }} className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-[#0a0a0f]/80 backdrop-blur-md border-b border-[#1e1e2e]' : 'bg-transparent'}`} data-id="element-94">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-95">
        <div className="flex items-center justify-between h-20" data-id="element-96">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center gap-2 cursor-pointer" onClick={() => window.scrollTo(0, 0)} data-id="element-97">
            <Shield className="h-8 w-8 text-[#00ff88]" data-id="element-98" />
            <span className="text-2xl font-bold tracking-wider text-white font-mono" data-id="element-99">
              IRONKEEP
            </span>
          </div>

          {/* Desktop Nav */}
          <div className="hidden md:block" data-id="element-100">
            <div className="ml-10 flex items-baseline space-x-8" data-id="element-101">
              {navLinks.map(link => <a key={link.name} href={link.href} className="text-[#a0a0b0] hover:text-[#00ff88] px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200 font-mono" data-id="element-102">
                  {link.name}
                </a>)}
              <button className="bg-[#00ff88]/10 text-[#00ff88] border border-[#00ff88] hover:bg-[#00ff88] hover:text-[#0a0a0f] px-4 py-2 rounded font-mono text-sm font-bold transition-all duration-300 shadow-[0_0_10px_rgba(0,255,136,0.1)] hover:shadow-[0_0_20px_rgba(0,255,136,0.4)]" data-id="element-103">
                ACCESS VAULT
              </button>
            </div>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden" data-id="element-104">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-[#a0a0b0] hover:text-white p-2" data-id="element-105">
              {isMobileMenuOpen ? <X className="h-6 w-6" data-id="element-106" /> : <Menu className="h-6 w-6" data-id="element-107" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-108">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-[#0a0a0f] border-b border-[#1e1e2e]" data-id="element-109">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3" data-id="element-110">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="text-[#a0a0b0] hover:text-[#00ff88] block px-3 py-2 rounded-md text-base font-medium font-mono" data-id="element-111">
                  {link.name}
                </a>)}
              <button className="w-full text-left text-[#00ff88] bg-[#00ff88]/10 border border-[#00ff88] px-3 py-2 rounded-md text-base font-bold font-mono mt-4" data-id="element-112">
                ACCESS VAULT
              </button>
            </div>
          </motion.div>}
      </AnimatePresence>
    </motion.nav>;
}